/** Bootstrap `lg`; keep in sync with `$grid-breakpoints.lg`. */
export const DESKTOP_MEDIA_QUERY = '(min-width: 992px)'
